// extracted by mini-css-extract-plugin
module.exports = {"EcocreditsRuleAnnounce":"EcocreditsRuleAnnounce_EcocreditsRuleAnnounce__t6V9L"};